module.exports = __webpack_public_path__ + "img/29.824bdc26.png";